import * as React from 'react';

/**
 * Same thing as useLayoutEffect but doesn't print a warning when used during SSR.
 */
export function useSafeLayoutEffect(
    effect: React.EffectCallback,
    deps?: React.DependencyList
): void {
    if (typeof window !== 'undefined') {
        // biome-ignore lint: this is safe
        React.useLayoutEffect(effect, deps);
    }
}
